import axios from 'axios';

type GetListingContactsParams = {
  listingId: string;
};

const getListingContacts = async (params: GetListingContactsParams) => {
  const { data: contacts } = await axios.get(
    `/appointments/${params.listingId}/config/contacts`,
  );

  return contacts;
};

export default getListingContacts;
